import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

// ----- DEV ORDER PERMISSION METHODS ----- //
export const getOrderPermission = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.ORDER_PERMISSION.GET}/${payload.type}`, {
      params: { devOrderId: payload.devOrderId, rangeplanId: payload.rangeplanId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const saveOrderPermission = async (params, payload) => {
  try {
    const urlParams = new URLSearchParams({ devOrderId: params.devOrderId });
    return await apiClient.post(
      params.type !== 'range-plan'
        ? `${apiEndpoint}${API.ORDER_PERMISSION.GET}/${params.type}?${urlParams}`
        : `${apiEndpoint}${API.ORDER_PERMISSION.GET}/${params.type}`,
      payload,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
